export const colWidth = (condition: boolean, colWidth: string) => (condition ? colWidth : undefined)
